import { ReactNode } from 'react';
import { useMediaQuery } from 'react-responsive';
import { useHydrated } from '../hooks/useHydrated';

function useMediaQueryAfterMount(query: Parameters<typeof useMediaQuery>[0]) {
  const matches = useMediaQuery(query);
  const hydrated = useHydrated();
  return hydrated ? matches : false;
}

export const Desktop = ({ children }: { children: ReactNode }) => {
  const isDesktop = useMediaQueryAfterMount({ minWidth: 768 });
  const isMobileLandscape = useMediaQueryAfterMount({
    query: '(max-width: 1000px) and (orientation: landscape)',
  });
  return isDesktop && !isMobileLandscape ? (
    <div className="desktop-mode">{children}</div>
  ) : null;
};

export const Mobile = ({ children }: { children: ReactNode }) => {
  const isMobile = useMediaQueryAfterMount({ maxWidth: 767 });
  const isMobileLandscape = useMediaQueryAfterMount({
    query: '(max-width: 1000px) and (orientation: landscape)',
  });
  return isMobile || isMobileLandscape ? (
    <div className="mobile-mode">{children}</div>
  ) : null;
};
